module.exports = __webpack_public_path__ + "202408221624/img/img_id_card_z_200_125@2x.2f8db72d.png";